export const getSavedReplies = (state) => {
  return state.saved_replies;
}